import React from 'react';
import styled from 'styled-components';

interface EpisodeSelectorProps {
  activeButton: number;
  onSelect: (value: number) => void;
}

export const TYPES = {
  'Initial Episode': 1,
  Recertification: 2,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const Label = styled.span`
  margin-right: 10px;
`;

const ButtonContainer = styled.div(({ theme }) => {
  return `
  display: flex;
  align-items: center;
  background: ${theme.color.grayscale[700]};
  padding: 3px;
  border-radius: 1000px;
  `;
});

const Button = styled.button<{ active: boolean }>`
  background: ${({ active }) => (active ? 'white' : 'none')};
  border: none;
  padding: 3px 6px;
  border-radius: 1000px;
`;

const EpisodeSelector: React.FC<EpisodeSelectorProps> = ({ activeButton, onSelect }) => {
  const handleClick = (value: number) => {
    onSelect(value);
  };

  return (
    <Wrapper>
      <Label>Choose Episode of Care</Label>
      <ButtonContainer>
        {Object.entries(TYPES).map(([label, value]) => (
          <Button key={value} active={activeButton === value} onClick={() => handleClick(value)}>
            {label}
          </Button>
        ))}
      </ButtonContainer>
    </Wrapper>
  );
};

export default EpisodeSelector;
